import React, { Component } from "react";
import { Statistic, Row, Col } from "antd";

class SeatInput extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { statisData } = this.props;
    return (
      <div className="address-static">
        <Row style={{ marginBottom: "16px" }} className="seat-statis">
          <Col span={4}>
            <Statistic title="地址总量" value={statisData.sum} />
          </Col>
          <Col span={4}>
            <Statistic title="地址已用量" value={statisData.isUsed} />
          </Col>
          <Col span={4}>
            <Statistic
              title="地址使用率"
              value={statisData.usageRate}
              suffix="%"
            />
          </Col>
        </Row>
        <Row
          style={{ marginBottom: "16px" }}
          className="address-static-border"
          gutter={8}
        >
          <Col span={6}>
            <Statistic title="注册且办公" value={statisData.settled} />
          </Col>
          <Col span={6}>
            <Statistic title="仅注册地址" value={statisData.onlyReg} />
          </Col>
          <Col span={6}>
            <Statistic title="免费提供" value={statisData.free} />
          </Col>
          <Col span={6}>
            <Statistic title="地址异常" value={statisData.error} />
          </Col>
        </Row>
      </div>
    );
  }
}
export default SeatInput;



// WEBPACK FOOTER //
// ./src/components/incubator/address/AddressStatic.js